import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import * as React from 'react';
import ApEditorMode from '../../../enums/ApEditorMode';
import { ApEditorActions } from '../../../sic-lib/reducers/actionPlanEditorReducer';
import MenuAddApActionRaw from './MenuAddApActionRaw/MenuAddApActionRaw';

interface Props {
    apEditMode: ApEditorMode;
    apDispatch: React.Dispatch<ApEditorActions>;
    /* TIP: contactId must not be undefined if editing typeof ApPlan */
    contactId: number | undefined;
}

export default function MenuAddApAction({ apEditMode, apDispatch, contactId }: Props) {
    const [menuId] = React.useState<string>('menu_add_ap_action');

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                aria-haspopup={true}
                aria-expanded={anchorEl !== null}
                aria-controls={menuId}
                onClick={handleOpen}
                startIcon={<AddIcon />}
            >
                Add Action
            </Button>
            <MenuAddApActionRaw
                menuId={menuId}
                anchorEl={anchorEl}
                onCloseHandler={handleClose}
                contactId={contactId}
                apEditMode={apEditMode}
                apDispatch={apDispatch}
            />
        </React.Fragment>
    );
}
